import { Spin } from 'antd';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { BasicTable } from '../../assets/common';
import { uniqueId } from 'lodash';

const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 24.2px;
  letter-spacing: 0.8333333134651184px;
  text-align: left;
`;

const Container = styled.section`
  background-color: ${(props) => props?.color};
  padding: 30px 24px;
  border-radius: 6px;
`;

const NameStyle = styled.span`
  cursor: pointer;
  font-weight: 700;
`;

const COLUMNS = [
  {
    title: 'Name',
    width: 200,
    dataIndex: 'birth_name',
    render: (text, record) => <NameStyle onClick={() => window.open('/profile/' + record.talent_id, '_blank')}>{text}</NameStyle>,
  },
  {
    title: 'Age',
    width: 80,
    dataIndex: 'age',
    render: (text) => <span>{text}</span>,
  },
  {
    title: 'Salary Grade',
    width: 80,
    dataIndex: 'sg',
    render: (text) => <span>{text}</span>,
  },
  {
    title: 'Retirement/ Contract End Date',
    width: 150,
    dataIndex: 'retirement_date',
    render: (text) => <span>{text ? moment(text).format('DD MMM YYYY') : ''}</span>,
  },
  {
    title: 'Year in Position',
    dataIndex: 'years_in_position',
    width: 150,
    render: (text) => <span>{text}</span>,
  },
  {
    title: 'Work Location',
    dataIndex: 'work_location',
    width: 150,
    render: (text) => <span>{text}</span>,
  },
];

const PreviousIncumbentDetail = (props) => {
  const { incumbent, fetchPositionIncumbentDetail } = props;

  const paginationConfig = {
    total: incumbent?.total,
    current: incumbent?.page,
    showSizeChanger: false,
    defaultPageSize: incumbent?.limit,
    onChange: (pageNum) => {
      pageNum !== incumbent?.page && fetchPositionIncumbentDetail && fetchPositionIncumbentDetail(pageNum);
    },
    showTotal: (total, range) => (
      <>
        Showing <b>{range[0]}</b> to <b>{range[1]}</b> of <b>{total}</b> results
      </>
    ),
  };

  return (
    <div>
      <Container color="#fff">
        <Container color="#F4F5F8">
          <Title>Position Holder Details</Title>
          <Spin spinning={incumbent?.loading}>
            <BasicTable
              rowKey="id"
              styles={{
                headerColor: '#8896A7',
                headerWeight: 700,
                borderRadius: 6,
                backgroundPagination: '#AFDDDC',
                borderColorPagination: '#AFDDDC',
                colorPagination: '#00645C',
              }}
              dataSource={incumbent?.data ? incumbent.data.map((m) => ({ ...m, key: uniqueId() })) : []}
              columns={COLUMNS}
              pagination={{ position: ['bottomRight'], ...paginationConfig }}
            />
          </Spin>
        </Container>
      </Container>
    </div>
  );
};

export default PreviousIncumbentDetail;
